'use strict'

const isEmpty_ = require('lodash/isEmpty')

const convertValueToString = require('../helpers/convertValueToString')
const getFieldValue = require('../helpers/getFieldValue')

module.exports = () => {
  const createOption = (record, { value }) => ({
    value: convertValueToString(getFieldValue(record, value.fieldName)),
    label: convertValueToString(getFieldValue(record, value.fieldName)) || ''
  })

  const updateComponent = async (
    { connectionConfig: { properties }, component: dropdown },
    actions
  ) => {
    if (!('value' in properties)) {
      return
    }

    const { items } = await actions.fetchAll()

    const options = items.map(record => createOption(record, properties))

    dropdown.options = options
  }

  return {
    isValidContext({ connectionConfig: { properties } }) {
      return !isEmpty_(properties)
    },

    bindToComponent({ component: dropdown }, actions) {},

    currentRecordModified: updateComponent,

    recordSetLoaded: updateComponent,

    currentViewChanged(componentAdapterContext, actions) {},

    currentIndexChanged({ component: dropdown }, actions) {}
  }
}



// WEBPACK FOOTER //
// ./adapters/dropdownOptionsAdapter.js